export default __webpack_public_path__ + "static/media/Modelo-de-alteração-de-contrato-de-socieda-unipessoal.ccb1f1c4.docx";